import React from 'react';
import { motion } from 'framer-motion';
export function HowItWorks() {
  const steps = [{
    number: '01',
    title: 'Contact Us',
    description: 'Tell us which family member you want to hire as your caregiver.'
  }, {
    number: '02',
    title: 'Mandatory Background Check',
    description: 'We run a thorough, mandatory background check and on-site fingerprinting to clear your family member.'
  }, {
    number: '03',
    title: 'Train & Certify',
    description: 'We provide CPR, First Aid, CNA training, and full caregiver certification — all on-site.'
  }, {
    number: '04',
    title: 'Approved & Caring',
    description: 'Your family member is now a licensed, approved caregiver — providing professional care to your loved one.'
  }];
  return <section id="how-it-works" className="py-24 px-4 bg-white overflow-hidden" data-id="element-177">
      <div className="max-w-7xl mx-auto" data-id="element-178">
        <div className="text-center max-w-3xl mx-auto mb-20" data-id="element-179">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-heading font-bold text-neutral-dark mb-4" data-id="element-180">
            How It Works
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-lg text-neutral-medium" data-id="element-181">
            Getting your family member certified is simple and fast.
          </motion.p>
        </div>

        <div className="relative" data-id="element-182">
          {/* Connecting Line (Desktop) */}
          <div className="hidden md:block absolute top-1/2 left-0 w-full h-0.5 bg-gray-100 -translate-y-1/2 z-0" data-id="element-183"></div>

          <div className="grid grid-cols-1 md:grid-cols-4 gap-12 md:gap-8 relative z-10" data-id="element-184">
            {steps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.15
          }} className="relative flex flex-col items-center text-center group" data-id="element-185">
                {/* Number Circle */}
                <div className="w-20 h-20 bg-white border-4 border-accent-light text-primary rounded-full flex items-center justify-center text-2xl font-heading font-bold mb-6 shadow-sm group-hover:border-accent group-hover:bg-accent group-hover:text-white transition-all duration-300" data-id="element-186">
                  {step.number}
                </div>

                <h3 className="text-xl font-heading font-bold text-neutral-dark mb-3" data-id="element-187">
                  {step.title}
                </h3>
                <p className="text-neutral-medium" data-id="element-188">{step.description}</p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}